import type { Expand } from "../types/Brand"
import { Partial } from "../functions/Partial"

// T = any object for props
// M = object of functions where first arg is self

type BoundMethods<T, M> = {
  [K in keyof M]: M[K] extends (self: T, ...args: infer Args) => infer R
    ? (...args: Args) => R
    : never
}

type EntityInstance<T, M> = Readonly<Expand<BoundMethods<T, M> & T>>

const EntityFactory = <T>() => {
  return <M extends { [K in keyof M]: (self: T, ...args: never[]) => unknown }>(
    methods: M
  ): ((props: T) => EntityInstance<T, M>) => {
    return (props: T): EntityInstance<T, M> => {
      const instance = { ...props }

      for (const key in methods) {
        ;(instance as any)[key] = Partial(
          methods[key],
          instance as unknown as T
        )
      }

      return instance as EntityInstance<T, M>
    }
  }
}

export { type BoundMethods, EntityFactory, type EntityInstance }
